angular.module('qkr')
    .controller('PerkController', ($scope, $rootScope, $routeSegment, $uibModalInstance, $timeout, savedReport,
                                   reportService, outletService, appConfig, utils, merchantService,
                                   gettextCatalog, messageService, reportsErrorService) => {
    const now = new Date().getTime();

    const defaultScheduleInterval = 'daily';
    const defaultScheduleHour = 17;
    const defaultScheduleMinute = 0;
    const defaultScheduleDay = utils.getDaysOfWeek()[0].name;
    const defaultScheduleDayOfMonth = 1;

    const constants = {};
    constants.sendProtocol = {};
    constants.sendProtocol.EMAIL = 'EMAIL';

    const isUpdating = !!savedReport;

    $scope.$routeSegment = $routeSegment;

    $scope.daysOfMonth = reportService.getDaysOfMonth();
    $scope.daysOfWeek = utils.getDaysOfWeek();  // Drop down menu to choose which day to generate weekly report
    $scope.days = utils.getDaysOfWeekWithSelected();   // Used to select which days a daily report should be generated
    $scope.scheduleIntervals = [];
    $scope.hours = reportService.getHours();
    $scope.minutes = reportService.getMinutes();

    $scope.templateReport = [];
    $scope.templateReportTemplate = [];

    $scope.form = {};

    $scope.outlets = [];

    $scope.NON_SCHEDULE = 0;
    $scope.SCHEDULE = 1;

    $scope.selectAll = [];

    $scope.perkReportSettings = {
        reportWaiting: false,
        reportUrl: '',
        showGenerateButton: !isUpdating
    };

    $scope.perkReport = {
        date: {
            startDate: now,
            startTime: reportService.getDateTime(0, 0, 0),
            endDate: now,
            endTime: reportService.getDateTime(23, 59, 59)
        },
        startTime: null,
        endTime: null,
        reportSpec: {
            merchantLocs: [],
            reportFileType: 'xls'
        }
    };

    $scope.perkReportTemplate = {
        reportSpec: {
            scheduleInterval: defaultScheduleInterval,
            scheduleHour: defaultScheduleHour,
            scheduleDay: defaultScheduleDay,
            scheduleDayOfMonth: defaultScheduleDayOfMonth,
            emailList: [],
            scheduleMinute: defaultScheduleMinute,
            merchantLocs: [],
            reportFileType: 'xls',
            sendProtocol: constants.sendProtocol.EMAIL
        }
    };

    const init = function() {
        $scope.showEmailOption = appConfig.isMCAdmin;

        // Get the beneficiary field names
        $scope.loading = true;
        merchantService.refreshMerchantInfo().then((merchant) => {
            $scope.merchant = merchant;

            if (merchantService.behaviour(merchant, 'transReportPage.showExtendedScheduleIntervals')) {
                $scope.scheduleIntervals = reportService.getExtendedScheduleIntervals();
            } else {
                $scope.scheduleIntervals = reportService.getScheduleIntervals();
            }

            if (isUpdating) {
                $scope.perkReportTemplate.reportSpec = savedReport;
                // Use radix parameters when calls parseInt, base 10
                $scope.perkReportTemplate.reportSpec.scheduleDayOfMonth =
                    parseInt($scope.perkReportTemplate.reportSpec.scheduleDayOfMonth, 10);
                utils.setSelectedDays($scope.perkReportTemplate.reportSpec.scheduleDay, $scope.days);
            }

            outletService.listOutlets()
                .then(
                (response) => {
                    const totalOutlets = response.length;

                    // Array of objects, it copy both arrays, because they are independent
                    $scope.outlets[$scope.NON_SCHEDULE] = angular.copy(response);
                    $scope.outlets[$scope.SCHEDULE] = angular.copy(response);

                    // Set all SelectedOutlets that's the default, update is just for schedule reports
                    if (isUpdating) {
                        $scope.popupObject.setCurrentPopup($scope.SCHEDULE);

                        angular.forEach($scope.outlets[$scope.SCHEDULE], (outlet) => {
                            angular.forEach(savedReport.merchantLocs, (savedOutlet) => {
                                if (outlet.id === savedOutlet.id) {
                                    outlet.selected = true;
                                    $scope.popupObject.manageSelectedOutlet(outlet.selected);
                                }
                            });
                        });

                        // Just for schedules, not saved
                        // Set the new field selected to true for each outlet
                        for (var i = 0; i < totalOutlets; i++) {
                            var outletNon = $scope.outlets[$scope.NON_SCHEDULE][i];

                            outletNon.selected = true;

                            $scope.popupObject.setCurrentPopup($scope.NON_SCHEDULE);
                            $scope.popupObject.manageSelectedOutlet(outletNon.selected);
                        }
                    } else {
                        // Set the new field selected to true for each outlet
                        for (var i = 0; i < totalOutlets; i++) {
                            var outletNon = $scope.outlets[$scope.NON_SCHEDULE][i];
                            const outlet = $scope.outlets[$scope.SCHEDULE][i];

                            // Set up all outlet to selected, schedule and non_schedule
                            outletNon.selected = true;
                            outlet.selected = true;

                            $scope.popupObject.setCurrentPopup($scope.NON_SCHEDULE);
                            $scope.popupObject.manageSelectedOutlet(outletNon.selected);

                            $scope.popupObject.setCurrentPopup($scope.SCHEDULE);
                            $scope.popupObject.manageSelectedOutlet(outlet.selected, $scope.SCHEDULE);
                        }
                    }
                }, (reason) => {
                    messageService.error(reason);
                }
            );
            $scope.loading = false;
        });
    };

    $scope.popupObject = (function() {
        // Current popup in the screen, it set when it opens the popup
        let currentPopupIndex;

        // Privates arrays, each popup has it own values
        let arrCountSelected = [0, 0], arrShowPopup = [false, false];

        return {

            getCountSelected(popupIndex) {
                // If it is called not from the popup it needs pass popupIndex
                return popupIndex !== undefined ? arrCountSelected[popupIndex] : arrCountSelected[currentPopupIndex];
            },

            getCurrentPopup() {
                return arrShowPopup[currentPopupIndex];
            },
            getCurrentPopupIndex() {
                return currentPopupIndex;
            },
            manageSelectedOutlet(selected) {
                if (!selected) {
                    arrCountSelected[currentPopupIndex] = arrCountSelected[currentPopupIndex] - 1;
                } else {
                    arrCountSelected[currentPopupIndex] = arrCountSelected[currentPopupIndex] + 1;
                }

                // If count is < length then set the check to false
                if (arrCountSelected[currentPopupIndex] < $scope.outlets[currentPopupIndex].length) {
                    // Ng-models for the checkbox
                    $scope.selectAll[currentPopupIndex] = false;
                } else {
                    $scope.selectAll[currentPopupIndex] = true;
                }
            },
            manageShowPopup(show) {
                arrShowPopup[currentPopupIndex] = show;

                // Cannot have more than 1 popup visible
                if (show) {
                    angular.forEach(arrShowPopup, (showing, key) => {
                        if (currentPopupIndex !== key) {
                            arrShowPopup[key] = false;
                        }
                    });
                }

                return arrShowPopup[currentPopupIndex];
            },
            manageSelectAll(all) {
                // Select all or none btn
                $scope.selectAll[currentPopupIndex] = all;
            },
            setCurrentPopup(popupIndex) {
                currentPopupIndex = popupIndex;
            },
            selectAllNone(selected) {
                if (!selected) {
                    // CountFiltered = 0;
                    arrCountSelected[currentPopupIndex] = 0;
                } else {
                    arrCountSelected[currentPopupIndex] = $scope.outlets[currentPopupIndex].length;
                }
            }

        };
    })();

    $scope.openFilterPopup = function(popupIndex) {
        $scope.popupObject.setCurrentPopup(popupIndex);

        if ($scope.popupObject.getCountSelected() === 0) {
            $scope.popupObject.manageSelectAll(false);
        }
        $scope.popupObject.manageShowPopup(true);
    };

    $scope.closePopupFilter = function() {
        $scope.popupObject.manageShowPopup(false);
    };

    const setSelectedOutlets = function(selectedOutlets) {
        $scope.outletSelected = [];

        if (!selectedOutlets) {
            angular.forEach($scope.outlets[$scope.popupObject.getCurrentPopupIndex()], (outlet) => {
                if (outlet.selected) {
                    $scope.outletSelected.push({id: outlet.id});
                }
            });
        } else {
            $scope.outletSelected = selectedOutlets;
        }
    };

    $scope.unselectedFiltered = function(selected) {
        $scope.popupObject.manageSelectedOutlet(selected);
    };

    $scope.selectAllOrNone = function(selected) {
        angular.forEach($scope.outlets[$scope.popupObject.getCurrentPopupIndex()], (outlet) => {
            outlet.selected = selected;
        });

        $scope.popupObject.selectAllNone(selected, $scope.popupObject.getCurrentPopupIndex());
    };

    var poll = function(id, format, reportType) {
        const timeoutPoll = $timeout(() => {
            // Poll for report
            reportService.pollReport(id)
                .then((promise) => {
                    // Check if error on the report
                    if (promise.error) {
                        handleGenerateReportError(promise);
                    } else if (promise.reportType === 'no-data') {
                        $scope.form.perkReportForm.errors = {generate: gettextCatalog.getString('No data for these criteria')};
                        $scope.perkReportSettings.reportWaiting = false;
                    }
                    // Check if complete, otherwise poll again
                    else if (promise.percentComplete === 100) {
                        $scope.form.perkReportForm.errors = {};
                        $scope.perkReportSettings.reportWaiting = false;
                        $scope.perkReportSettings.reportUrl = appConfig.apiUrl + 'reportControl/' + promise.id + '/' + format;
                        window.location = $scope.perkReportSettings.reportUrl;
                    } else {
                        poll(id, format, reportType);
                    }
                },
                (error) => {
                    handleGenerateReportError(error);
                });
        }, 2500);

        $scope.$on(
            '$destroy',
            (event) => {
                $timeout.cancel(timeoutPoll);
            }
        );
    };

    var handleGenerateReportError = function(error) {
        let errors = {};

        if ($scope.form.perkReportForm.errors) {
            errors = $scope.form.perkReportForm.errors;
        }
        errors.generate = gettextCatalog.getString('Error generating report');
        $scope.form.perkReportForm.errors = errors;
        $scope.perkReportSettings.reportWaiting = false;
    };

    $scope.generatePerkReport = function() {
        $scope.perkReportSettings.reportWaiting = true;

        const request = angular.copy($scope.perkReport);

        request.reportSpec.scheduleInterval = 'once';
        request.startTime = utils.dateTimeToServerDateTimeString($scope.perkReport.date.startDate, $scope.perkReport.date.startTime); // Start of day
        request.endTime = utils.dateTimeToServerDateTimeString($scope.perkReport.date.endDate, $scope.perkReport.date.endTime); // End of day

        request.reportSpec.customFields = [];

        // Set array outletsSelected to be send, in this case is going to loop again because is another array...
        // That is going to be send
        $scope.popupObject.setCurrentPopup($scope.NON_SCHEDULE);
        setSelectedOutlets();

        request.reportSpec.merchantLocs = $scope.outletSelected;

        if ($scope.popupObject.getCountSelected($scope.NON_SCHEDULE) === 0) {
            $scope.form.perkReportForm.errors = {outletFilterGenerate: gettextCatalog.getString('Should at least select one Outlet')};

            $scope.perkReportSettings.reportWaiting = false;
            return;
        }

        delete (request.date);
        delete (request.reportSpec.reportFileType);

        reportService.generatePerkReport(request).then(
            (promise) => {
                poll(promise.id, 'excel', 'perk');
            },
            (error) => {
                handleGenerateReportError(error);
            }
        );
    };

    /**
     * Set the merchantLocs that are selected in the report spec (that will be
     * sent to server)
     */

    $scope.savePerkReport = function() {
        if (!validateReport()) {
            return;
        }

        $scope.saving = true;

        const request = angular.copy($scope.perkReportTemplate.reportSpec);

        // Set array outletsSelected to be send, in this case is going to loop again because is another array...
        // That is going to be send
        $scope.popupObject.setCurrentPopup($scope.SCHEDULE);
        setSelectedOutlets();

        request.merchantLocs = $scope.outletSelected;

        if (request.scheduleInterval === 'daily') {
            request.scheduleDay = utils.getSelectedDaysList($scope.days);
        }

        // Are we updating or creating, if savedReport object passed to modal we
        // Are updating, otherwise we are creating
        if (!isUpdating) {
            request.id = null;
        }

        reportService.savePerkReport(request, isUpdating).then(
            () => {
                $uibModalInstance.close(true);
            },
            (err) => {
                $scope.form.perkReportForm.errors = reportsErrorService
                    .handleServerError(err.data.errors);
            }
        ).finally(
            () => {
                $scope.saving = false;
            }
        );
    };

    var validateReport = function() {
        // Empty the errors list
        $scope.errors = null;
        let valid = true;
        const errors = {};

        // Check name is set
        if ($scope.form.perkReportForm.name.$invalid) {
            errors.name = gettextCatalog.getString('Name is required');
            valid = false;
        }

        // Check at least 1 email is added
        if ($scope.perkReportTemplate.reportSpec.emailList.length <= 0) {
            errors.email = gettextCatalog.getString('At least 1 email address is required');
            valid = false;
        }

        if ($scope.popupObject.getCountSelected($scope.SCHEDULE) === 0) {
            errors.outletFilterSave = gettextCatalog.getString('Should at least select one Outlet');

            valid = false;
        }

        $scope.form.perkReportForm.errors = errors;

        return valid;
    };

    $scope.addPerkReportEmail = function() {
        // Gets ride of validation warning
        if ($scope.form.perkReportForm.errors && $scope.form.perkReportForm.errors.email) {
            $scope.form.perkReportForm.errors.email = '';
        }
        $scope.perkReportTemplate.reportSpec.emailList.push($scope.perkReportSettings.email);
        $scope.perkReportSettings.email = '';
    };

    $scope.removePerkReportEmail = function(index) {
        $scope.perkReportTemplate.reportSpec.emailList.splice(index, 1);
    };

    $scope.cancel = function() {
        $uibModalInstance.dismiss('cancel');
    };

    /** Called when day is toggled in daily report */
    $scope.changeDayEnabled = function(day) {
        day.selected = !day.selected;
    };

    $scope.dateOptions = {
        startingDay: $rootScope.merchantInfo.contactDetails.country.weekStartingDay,
        showWeeks: false
    };

    init();
});



// WEBPACK FOOTER //
// ./src/reports/merchant/shared/perk.controller.js